<template>
  <div>
    <div id="livechat" v-if="$store.getters.getPackage == 'premium'">
      <v-layout wrap fill-height>
        <v-flex xs3 fill-height style="border-right: 1px solid #eee;">
          <div id="chattype" class="text-xs-center">
            <v-layout>
              <v-flex>
                <v-btn
                  depressed
                  style="border-radius: 0;width: 100%"
                  class="ma-0 pa-0"
                  :color="app == 'facebook' ? 'primary' : 'grey'"
                  @click="app = 'facebook'"
                  dark
                >
                  <i class="fab fa-facebook"></i>
                </v-btn>
              </v-flex>
              <v-flex>
                <v-btn
                  depressed
                  style="border-radius: 0;width: 100%"
                  class="ma-0 pa-0"
                  :color="app == 'line' ? 'primary' : 'grey'"
                  @click="app = 'line'"
                  dark
                >
                  <i class="fab fa-line"></i>
                </v-btn>
              </v-flex>
              <v-flex>
                <v-dialog v-model="showSearch" width="500">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      depressed
                      style="border-radius: 0;width: 100%"
                      class="ma-0 pa-0"
                      v-on="on"
                    >
                      <v-icon>search</v-icon>
                    </v-btn>
                  </template>

                  <v-card>
                    <div class="text-xs-right">
                      <v-btn flat fab small @click="showSearch = false">
                        <v-icon>close</v-icon>
                      </v-btn>
                    </div>

                    <v-card-text>
                      <div class="caption">{{ $t('Search') }}</div>
                      <div class="form-control">
                        <input type="text" v-model="filter.search" :placeholder="$t('Search')" />
                      </div>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-flex>
            </v-layout>
            <v-tabs
              id="usertype"
              v-model="type"
              color="grey lighten-3"
              :slider-color="$vuetify.theme.primary"
              @change="changeType"
            >
              <v-tab ripple :key="'admin'" :href="'#admin'">{{ $t('Inbox') }}</v-tab>
              <v-tab ripple :key="'bot'" :href="'#bot'">{{ $t('Bot') }}</v-tab>
            </v-tabs>
          </div>

          <users :app="app" :filter="filter" :type="'admin'" v-if="type == 'admin'"></users>
          <users :app="app" :filter="filter" :type="'bot'" v-if="type == 'bot'"></users>
        </v-flex>
        <v-flex
          xs5
          style="border-right: 1px solid #eee; position: relative"
          fill-height
          v-if="selectedUser"
          :key="`chat_${selectedUser.userid}_${selectedUser.type}`"
        >
          <chatbox
            @endSession="onEndSession"
            @openSession="onOpenSession"
            :key="selectedUser.userid"
          ></chatbox>
        </v-flex>
        <v-flex xs4 style=" position: relative" fill-height v-if="selectedUser">
          <div id="chattool" class="text-xs-center">
            <v-tabs
              v-model="chattooltype"
              color="grey lighten-3"
              :slider-color="$vuetify.theme.primary"
            >
              <v-tab ripple :key="'customer'" :href="'#customer'">{{ $t('Customer') }}</v-tab>
              <!-- <v-tab ripple :key="'conversation'" :href="'#conversation'">{{$t('Conversation')}}</v-tab> -->
            </v-tabs>
          </div>

          <div
            id
            style="overflow-y:auto"
            v-resize="onResizeToolList"
            :style="{ height: toolListHeight + 'px' }"
          >
            <div v-if="chattooltype == 'customer'">
              <livechat-customers
                v-model="selectedUser"
                :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
              ></livechat-customers>
            </div>
            <div v-else-if="chattooltype == 'conversation'">
              <div class="pa-1 form-control">
                <input type="text" class="form-control" :placeholder="$t('Search')" />
              </div>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div v-else style="position: relative">
      <v-premium-plan-popup
        backgroundColor="white"
        v-if="$store.getters.getPackage != 'premium'"
        style="border-radius: 10px;min-height: 100vh; height: 100%; "
      ></v-premium-plan-popup>
    </div>
  </div>
</template>

<style></style>

<script>
import { mapGetters } from 'vuex'
import users from './livechat-users'
import chatbox from './livechat-chatbox'
import api from '@/api'
import LivechatCustomers from './livechat-customers'

export default {
  components: {
    chatbox: chatbox,
    users: users,
    LivechatCustomers
  },
  data: function() {
    return {
      app: 'facebook',
      type: 'bot',

      toolListHeight: 0,
      chattooltype: 'customer',
      showSearch: false,
      filter: {
        search: ''
      }
    }
  },

  mounted: function() {
    var vm = this
    if (vm.$route.query.user) {
      vm.type = vm.$route.query.user == 'bot' ? 'bot' : 'admin'
    }

    vm.onResizeToolList()
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      selectedUser: 'getCurrentUser'
    })
  },
  methods: {
    onEndSession: function() {
      this.$set(this.$store.state.livechat, 'currentUser', null)
      this.$store.dispatch('updateLivechatUser', null)
      this.$store.dispatch('forceLoadLastestUsers')
    },
    onOpenSession: function() {
      this.type = 'admin'
      var user = this.$store.state.livechat.currentUser
      user.type = this.type
      this.$store.dispatch('updateLivechatUser', user)
      this.$store.dispatch('forceLoadLastestUsers')
      this.updateRoute()
    },
    changeType: function(name) {
      this.type = name
      this.updateRoute()
    },
    updateRoute: function() {
      this.$router.push({
        name: 'livechat',
        path: '/livechat',
        query: {
          user: this.type
        }
      })
      this.routeValue = JSON.stringify(this.$route.query)
    },

    onResizeToolList: function() {
      var vm = this
      vm.$nextTick(function() {
        var toolListHeight = 0
        if (document.getElementById('chattool')) {
          toolListHeight = document.getElementById('chattool').clientHeight
        }
        vm.toolListHeight =
          window.innerHeight - document.getElementById('main_toolbar').clientHeight - toolListHeight
      })
    },
    sendMessage: function(payload) {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid,
        userid: payload.data.user.userid,
        app: payload.data.app,
        messagetype: payload.data.type,
        messagevalue: payload.data.text,
        page_access_token: vm.selectedBot.page_access_token
      }

      let message = {
        answerby: 'admin',
        id: new Date().getTime(),
        messagedata: payload.data.text,
        messagetype: payload.data.type,
        pageid: vm.selectedBot.pageid,
        timestamp: new Date(),
        userid: payload.data.user.userid
      }

      api.sendMessage(data, function(error, response) {
        if (error) {
          console.error(error)
          // vm.$store.dispatch('loading')
          return
        }
        // vm.$store.dispatch('loading')
      })
    }
  },
  watch: {
    selectedBot: function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.$set(this.$store.state.livechat, 'currentUser', null)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/livechat/Livechat.vue